<template>
  <div>
    <div class="field" :class="fieldClassObject">
      <button
        class="cta"
        :class="ctaClassObject"
        :disabled="disabledAttribute"
        ref="submit"
        :type="onclick ? 'button' : 'submit'"
        v-on="onclick ? { click: onclick } : {}"
        :id="ctaId"
      >{{ buttonText }}</button>
      <SubmitMessage
        ref="submitMessage"
        :stopEditingHandler="stopEditingHandler"
        :errorCount="errorCount"
        :hasSubmitError="hasSubmitError"
        :submittedSuccessfully="submittedSuccessfully"
        :successMessage="successMessage"
        :errorMessage="errorMessage"
      />
    </div>
  </div>
</template>

<script>
/**
 * @file SubmitButton
 * @author pierre-michel@on-running.com
 *
 * Use this button in the form using "submit-form" mixin to display the error message coming from
 * the server below the button (or the generic error message "Please correct the fields marked in
 * red.").
 */

import SubmitMessage from './SubmitMessage.vue'

export default {
  name: 'SubmitButton',
  components: {
    SubmitMessage,
  },

  props: {
    fieldClass: String,
    onclick: Function,
    buttonText: {
      type: String,
      required: true,
    },
    stopEditingHandler: Function,
    errorCount: {
      type: Number,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isSubmitting: {
      type: Boolean,
      required: true,
    },
    hasSubmitError: {
      type: Boolean,
      required: true,
    },
    submittedSuccessfully: Boolean,
    successMessage: String,
    errorMessage: String,
    ctaId: String,
    ctaModifiers: {
      type: Array,
      default: () => ['large', 'primary'],
    },
  },

  computed: {
    fieldClassObject() {
      const classObject = {}
      classObject[this.fieldClass] = this.fieldClass
      return classObject
    },

    ctaClassObject() {
      const classObject = { 'cta--loading': this.isSubmitting }
      this.ctaModifiers.forEach(modifier => {
        classObject[`cta--${modifier}`] = true
      })
      return classObject
    },

    disabledAttribute() {
      return this.isDisabled || this.isSubmitting ? 'disabled' : false
    },
  },

  mounted() {
    if (!this.$parent.$refs.submitCta) {
      throw 'ref="submitCta" is missing on <SubmitButton>'
    }
  },
}
</script>
